// api.ts
import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios';
import { Toast } from 'react-vant';
import { getArgFromUrl } from '@dana/components';
import { getInitialLanguage } from '../lang/language';

// 获取参数值
const token = getArgFromUrl('token');
const language = getInitialLanguage();

// 定义一个通用的接口来表示响应数据的类型
interface ApiResponse<T> {
  data: T;
  message?: string;
}

// 定义请求方法类型
type RequestMethod = 'GET' | 'POST';

// 创建 Axios 实例并配置
const axiosInstance: AxiosInstance = axios.create({
  baseURL:
    process.env.REACT_APP_ENV === 'development'
      ? 'http://192.168.0.233:9000/api/v1'
      : 'https://apiv2.danachatapp.com/api/v1/',
  timeout: 5000, // 设置请求超时限制
  headers: {
    H5Token: encodeURIComponent(`${token}`).replace(/%20/g, '%2B'),
    'Content-Type': 'application/json', // 默认请求头
    language: language,
  },
});

// 封装的请求方法，包含类型支持
async function request<T>(
  method: RequestMethod,
  url: string,
  data: any = null,
  config?: AxiosRequestConfig, // 额外的配置选项
): Promise<T | undefined> {
  try {
    let response: AxiosResponse<ApiResponse<T>>;

    if (method === 'GET') {
      response = await axiosInstance.get<ApiResponse<T>>(url, config);
    } else if (method === 'POST') {
      response = await axiosInstance.post<ApiResponse<T>>(url, data, config);
    } else {
      throw new Error('Unsupported HTTP method');
    }
    if (!response.data.data && (response.data as any).msg) {
      Toast((response.data as any).msg);
    }
    if (!response.data) {
      Toast('error');
    } else {
      // 返回成功的响应数据
      return response.data.data;
    }
  } catch (error: any) {
    // 错误处理，带类型推断
    if (error.response) {
      console.error('Error Response:', error.response.data);
      console.error('Error Status:', error.response.status);
      console.error('Error Headers:', error.response.headers);
      throw new Error(error.response.data.message || 'Request failed');
    } else if (error.request) {
      console.error('Error Request:', error.request);
      throw new Error('No response received from server');
    } else {
      console.error('Error Message:', error.message);
      throw new Error('Request configuration error');
    }
  }
}

export default request;
